module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/area-3-448c2a9eebe8caaacd6fe6413bd61529.jpg";